<template>
  <div class="content OverviewOrderView">
    <div
      class="container-fluid"
      :class="{
        'disable-ske': !loading,
      }"
    >
      <card class="images-wrapper mb-2" body-class="images-wrapper">
        <h4 class="card-title p-2">
          Bestellingen
        </h4>

        <div v-if="loading" class="scroller p-2">
          <Carousel class="carousel">
            <OrderItem v-for="(item, i) in placeholderList" :key="item.sku + i"
              v-bind="item"
            />
          </Carousel>
        </div>
        <div v-else-if="ordersWithImages && ordersWithImages.length" class="scroller p-2">
          <Carousel class="carousel">
            <OrderItem v-for="(item, index) in ordersWithImages" :key="item.sku"
              v-bind="item"

              @remove="removeOrder(index)"
            />
          </Carousel>
        </div>
        <div v-else class="py-4 empty-state-wrapper d-flex justify-content-center">
          <EmptyStatePlaceholder
            title="Er zijn geen bestellingen"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
              <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1V5a1 1 0 00-1-1H3zM14 7a1 1 0 00-1 1v6.05A2.5 2.5 0 0115.95 16H17a1 1 0 001-1v-5a1 1 0 00-.293-.707l-2-2A1 1 0 0015 7h-1z" />
            </svg>
          </EmptyStatePlaceholder>
        </div>
      </card>

      <div class="d-flex justify-content-between flex-lg-row flex-wrap details-wrapper">
        <div class="sub-col">
          <card class="mb-0">
            <h4 class="card-title p-2">
              Details
            </h4>

            <GeneralDetails
              :vuelidate="$v"
              :disabled="disabled"
              :editing="true"
            />
          </card>
        </div>
        <div class="sub-col">
          <card class="mb-0">
            <h4 class="card-title p-2">
              Shipping Address
            </h4>

            <AddressForm
              :vuelidate="$v.shippingAddress"
              :disabled="disabled"
            />
          </card>
        </div>
        <div class="sub-col">
          <card class="mb-0">
            <h4 class="card-title p-2">
              Invoice Address
            </h4>

            <AddressForm
              :vuelidate="$v.invoiceAddress"
              :disabled="disabled"
            />
          </card>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-2">
        <span class="ske">
          <button type="button" class="btn btn-secondary" id="go-back" data-dismiss="modal" @click="goBack">
            Terug
          </button>
        </span>
        <span v-if="!disabled" class="ske">
          <button type="button" class="btn btn-primary" id="submit-button" @click="save">
            Opslaan
          </button>
        </span>
        <span v-else></span>
      </div>
    </div>
  </div>
</template>

<script>

import OrderItem from "./OrderItem.vue"
import AddressForm from "../../components/OrderForms/AddressForm.vue"
import FormInput from "/src/components/Inputs/FormInput.vue"
import Carousel from "../../layout/Carousel.vue"
import GeneralDetails from "../../components/OrderForms/GeneralDetails.vue"

import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"

const placeholder = {
  name: "qui",
  price: "978.00",
  qty: 3,
  sku: "tempore",
}

const fields = [
  "site", "orderNumber", "orderDate", "language", "orders", "shipmentTrackAndTrace",
]

const addressFields = [
  "firstName", "lastName", "street", "houseNumber", "houseNumberExtension", "postalCode", "city", "countryCode", "telephone", "email",
]

export default {
  metaInfo() {
    const order = this.order

    return {
      title: order ? `${order.site} - Order` : "Order Informatie"
    }
  },
  components: {
    AddressForm,
    FormInput,
    GeneralDetails,
    OrderItem,
    EmptyStatePlaceholder,
    Carousel,
  },
  data() {
    return {
      state: null,
      order: null,
      loading: true,

      orders: [],
      orderImages: {},
      placeholder,

      ...fields.reduce((obj, key) => ({
        ...obj,
        [key]: "",
      }), {}),

      shippingAddress: {
        ...addressFields.reduce((obj, key) => ({
          ...obj,
          [key]: "",
        }), {}),
      },
      invoiceAddress: {
        ...addressFields.reduce((obj, key) => ({
          ...obj,
          [key]: "",
        }), {}),
      },
    }
  },
  validations: {
    ...fields.reduce((obj, key) => ({
      ...obj,
      [key]: {},
    }), {}),

    shippingAddress: {
      ...addressFields.reduce((obj, key) => ({
        ...obj,
        [key]: {},
      }), {}),
    },
    invoiceAddress: {
      ...addressFields.reduce((obj, key) => ({
        ...obj,
        [key]: {},
      }), {}),
    },
  },
  async created() {
    this.load()
  },
  methods: {
    goBack() {
      this.$router.push("/admin/overview-order").catch(()=>{})
    },
    async loadImages() {
      const orders = this.orders

      const orderImages = {}
      await Promise.all(
        orders.map(async ({ sku }) => {
          try {
            const results = (await this.axios.get(`/api/products/${sku}/files`)).data.results

            if (results && results[0]) {
              orderImages[sku] = results[0].url
            }
          } catch(e) {
            console.log('failed to download the files for the order line')
          }
        })
      )
      this.orderImages = orderImages
    },
    async load() {
      this.loading = true

      const order = (await this.axios.get(`/api/orders/${this.id}`)).data
      if (order) {
        this.orders = order.orders
        await this.loadImages()
        this.state = order.state

        fields.forEach(key => this.$v[key].$model = order[key])
        addressFields.forEach(key => this.$v.shippingAddress[key].$model = order.shippingAddress[key])
        addressFields.forEach(key => this.$v.invoiceAddress[key].$model = order.invoiceAddress[key])
      }
      this.order = order

      this.loading = false
    },
    async removeOrder(index) {
      const orders = this.orders.slice()
      orders.splice(index, 1)

      await this.$handlePromise(async () => {
        await this.axios.put(`/api/orders/${this.id}`, {
          ...this.orderDetails,

          orders,
        })

        this.$success("Een bestelling verwijderd!")
        await this.load()
      })
    },
    async save() {
      await this.$handlePromise(async () => {
        await this.axios.put(`/api/orders/${this.id}`, {
          ...this.orderDetails,
        })
        this.$success("Bestelling bijgewerkt!")

        this.$router.push("/admin/overview-order").catch(()=>{})
      })
    },
  },
  computed: {
    orderDetails() {
      return {
        ...fields.reduce((obj, key) => ({
          ...obj,
          [key]: this.$v[key].$model,
        }), {}),

        shippingAddress: {
          ...addressFields.reduce((obj, key) => ({
            ...obj,
            [key]: this.$v.shippingAddress[key].$model,
          }), {}),
        },
        invoiceAddress: {
          ...addressFields.reduce((obj, key) => ({
            ...obj,
            [key]: this.$v.invoiceAddress[key].$model,
          }), {}),
        },
      }
    },

    id() {
      return this.$route.params.id
    },
    ordersWithImages() {
      const images = this.orderImages
      return this.orders.map(item => ({...item, src: images[item.sku]}))
    },
    disabled() {
      return this.state !== "NOT_SENT" && this.state !== "SENT_TO_POSTNL" && this.state !== "CANCELED"
    },
    placeholderList() {
      const p = this.placeholder
      return [p,p,p,p,p,p]
    },
  },
}

</script>

<style>

.images-wrapper .card-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.OverviewOrderView .card-body {
  padding: 0px !important;
}

</style>

<style scoped>

.col-xl-9, .col-xl-3 {
  padding: 0;
}

.col-xl-3 {
  padding-top: 14px;
}

.sub-col {
  width: 100%;
}
.sub-col:nth-child(2) {
  margin-top: 8px;
  margin-bottom: 8px;
}

@media (min-width: 768px) {
  .sub-col {
    width: calc((100% / 2) - 2px);
  }

  .sub-col:nth-child(2) {
    margin-top: 0;
  }
}

@media (min-width: 1200px) {
  .sub-col {
    width: calc(100% / 3 - 4px);
  }
}

.scroller {
  display: flex;
  height: 100%;
  position: relative;
  flex-wrap: nowrap;
  overflow: auto;
}

.images-wrapper {
  width: 100%;
}

.empty-state-wrapper {
  width: 100%;
}

.card-title {
  padding-bottom: 0px !important;
}

@media (min-width: 1200px) {
  .col-xl-3 {
    padding-top: 0;
    padding-left: 14px;
  }
}

</style>
